export function SetProcessCreateOtherSectionVisibility(isVisible: boolean) {
    if (isVisible) {
        $('#other-section').show();
        $('#other-section-title').show();
    } else {
        if ($('#other-table tr[style=\'display: none;\']').length === $('#other-table tr').length) {
            $('#other-section-title').hide();
            $('#other-section').hide();
        }
    }
}
